import { motion } from "framer-motion";
import { CLIENTS } from "@/lib/media";

// All logos are now dark/monochrome — same grayscale + opacity treatment.
const LOGOS = [
    { name: CLIENTS.hks.name, src: CLIENTS.hks.logo, key: "hks" },
    {
        name: CLIENTS.karnani.name,
        src: CLIENTS.karnani.logo,
        key: "karnani",
    },
    {
        name: CLIENTS.gvEcostays.name,
        src: CLIENTS.gvEcostays.logo,
        key: "gv-ecostays",
    },
    {
        name: CLIENTS.logoinfosoft.name,
        src: CLIENTS.logoinfosoft.logo,
        key: "logoinfosoft",
    },
    { name: CLIENTS.scf.name, src: CLIENTS.scf.logo, key: "scf" },
    {
        name: CLIENTS.sudamaFarms.name,
        src: CLIENTS.sudamaFarms.logo,
        key: "sudama-farms",
    },
];

const ease = [0.22, 1, 0.36, 1];

export default function TrustedBy() {
    return (
        <section
            data-testid="trusted-by-section"
            className="relative py-14 lg:py-20 border-t border-b border-black/10 bg-bone"
        >
            <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
                <div className="flex flex-col lg:flex-row lg:items-center gap-8 lg:gap-14">
                    <div className="lg:w-1/4">
                        <div className="text-[10px] uppercase tracking-[0.22em] font-bold text-black/50">
                            / Trusted by ambitious brands
                        </div>
                        <div className="mt-2 font-serif italic text-lg lg:text-xl text-black/70 leading-snug max-w-xs">
                            A small studio, a growing family of partners.
                        </div>
                    </div>

                    <div className="flex-1 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 items-center gap-x-4 gap-y-6 lg:gap-x-6">
                        {LOGOS.map((l, i) => (
                            <motion.div
                                key={l.key}
                                data-testid={`trusted-logo-${l.key}`}
                                initial={{ opacity: 0, y: 12 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{
                                    duration: 0.7,
                                    ease,
                                    delay: i * 0.05,
                                }}
                                className="flex items-center justify-center h-16 group cursor-default"
                                title={l.name}
                            >
                                <img
                                    src={l.src}
                                    alt={l.name}
                                    className="max-h-full max-w-full object-contain filter grayscale opacity-85 group-hover:opacity-100 group-hover:grayscale-0 group-hover:scale-105 transition-all duration-500"
                                    loading="lazy"
                                />
                            </motion.div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
